/**
 * Composant de garde de route admin : redirige si non admin.
 */

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminRoute() {
  const { user } = useAuth();

  if (!user || user.role !== "admin") {
    return <Navigate to="/contacts" replace />;
  }

  return <Outlet />;
}
